import { cn } from '@lib/cn'
import React, { AnchorHTMLAttributes, ButtonHTMLAttributes, FC } from 'react'

type BaseLink = {
  variant?: 'brown' | 'blue' | 'grey'
}

type Link = BaseLink &
  AnchorHTMLAttributes<HTMLAnchorElement> & {
    as?: 'link'
  }

type Button = BaseLink &
  ButtonHTMLAttributes<HTMLButtonElement> & {
    as?: 'button'
  }

type LinkType = Link | Button

type StyledLinkProps = BaseLink & LinkType

export const styledLinkStyle = cn(
  'font-special text-[9px] uppercase tracking-[0.28em] leading-[1.45]',
  'md:text-[11px]',
)

export const StyledLink: FC<StyledLinkProps> = React.forwardRef((props, ref: any) => {
  const { as, children, variant = 'blue', className, ...rest } = props
  const Element: any = as === 'link' ? 'a' : 'button'

  return (
    <Element
      ref={ref}
      data-variant={variant}
      className={cn(
        'duration-250 w-auto items-center border-b border-solid border-current p-0 pb-1 leading-[1.45] outline-0 transition-all ease-in-out',
        variant === 'blue' && 'text-bigStone',
        variant === 'brown' && 'text-tabaccoBrown',
        variant === 'grey' && 'text-shade500',
        'disabled:cursor-not-allowed disabled:opacity-40',
        styledLinkStyle,
        className,
      )}
      {...rest}
    >
      {children}
    </Element>
  )
})
